import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Components 
import { Grid } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { T } from 'Actions/translate';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';

class PackageDetailsDialog extends Component {

	state = {
		receiveExitOpened: false,
		expand: false,
		packageConditionCount: 0
	}
	
    componentDidUpdate() {
		const dialogMask = ReactDOM.findDOMNode(document.getElementsByClassName('dialog-mask')[0]);
		if (dialogMask !== null && this.props.opened) {
			const dialogWrap = dialogMask.children[0];
			const dialogMaskHeight = dialogMask.clientHeight;
			const dialogWrapOffsetHeight = dialogWrap.offsetHeight;
			if (document.getElementById('skuConditionUl') !== null) {
				if (dialogMaskHeight !== 0 && dialogWrapOffsetHeight !== 0) {
					if(dialogWrapOffsetHeight > dialogMaskHeight) {
						document.getElementsByClassName('dialog-warp')[0].style.top = '0%';
						document.getElementsByClassName('dialog-warp')[0].style.WebkitTransform = 'translateX(-50%)';
					} else {
						document.getElementsByClassName('dialog-warp')[0].style.top = '50%';
						document.getElementsByClassName('dialog-warp')[0].style.WebkitTransform = 'translate(-50%, -50%)';
					}

				}
			}
		}
	}
    shipConfirmationHandle = () => {
        this.props.shipConfirmationHandle();
	}

	closeDialog = (name) => {
		this.setState({ expand: false });
		document.getElementsByClassName('dialog-warp')[0].style.top = '50%';
		document.getElementsByClassName('dialog-warp')[0].style.WebkitTransform = 'translate(-50%, -50%)';
		this.props.closeDialog(name);
	}

	showConditionContent = (skuReplenishmentDetailData) => {
        return (
			<div className='package-condition-detail'>
				<ul className="f1-order-sku-condition-list" id="skuConditionUl">
					{
						skuReplenishmentDetailData !== null && skuReplenishmentDetailData.length === 0 ? <li className='sku-condition-li'><label className='not-receive-package'>{T('host_receive_not_package_condition')}</label></li> : skuReplenishmentDetailData.map((skuCondition, index) => (
                           <li key={index} className={index > 1 ? 'sku-condition-li hidden-sku-kit' : 'sku-condition-li'}>
							   <div className='sku-condition'>
									<div className='sku-condition-detail'>
										<p className='sku-content text-ellipsis sku-style-set'><label>{T('backup_sku')}:</label>{skuCondition.sku}</p>
									</div>
									<div className='storage-condition-detail'>
										<p className='storage-condition-content text-ellipsis'><label>{T('fone_order_storage_condition')}:</label>{skuCondition.storageCondition}</p>
									</div>
									<div className='shipping-condition-detail'>
										<div className='shipping-condition-content text-ellipsis'><label>{T('fone_order_shipping_condition')}:</label>{skuCondition.shippingCondition}</div>
									</div>
									{skuCondition.components !== null ? this.renderSkuKit(skuCondition.components) : null}
							   </div>
						   </li>
						))
					}
				</ul>
				{ skuReplenishmentDetailData !== null && skuReplenishmentDetailData.length > 2 ? <Grid item xs={12} id="expandBtn" align="center">
                    <BasicButton className="expand-more-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.expandPackageCondition()}>
						<span>{this.state.expand ? <ExpandLess /> : <ExpandMore />}</span>
					</BasicButton>
				</Grid> : null}
			</div>
		);
	}

    renderSkuKit = (skuKitComponents) => {
        return (
			<div className='sku-kit-detail'>
				<div className='sku-kit-content text-ellipsis'>{T('fone_order_kit_detail')}:</div>
				<ul className='sku-kit-list'>
					{
						skuKitComponents.map((skuKitCondition, kitIndex) => (
							<li key={kitIndex} className='sku-kit-li'>
								<div className='sku-kit'>
										<div className='kit-sku-condition-detail'>
											<p className='sku-kit-content text-ellipsis'><label>{T('backup_sku')}:</label>{skuKitCondition.sku}</p>
										</div>
										<div className='kit-storage-condition-detail'>
											<p className='kit-storage-condition-content text-ellipsis'><label>{T('fone_order_storage_condition')}:</label>{skuKitCondition.storageCondition}</p>
										</div>
										<div className='kit-shipping-condition-detail'>
											<div className='kit-shipping-condition-content text-ellipsis'><label>{T('fone_order_shipping_condition')}:</label>{skuKitCondition.shippingCondition}</div>
										</div>
								</div>
							</li>
						))
					}
				</ul>
		    </div>
		);
	}

	expandPackageCondition = () => {
		const expand = this.state.expand;
		if(expand) {
			for (let i=0; i < document.getElementById('skuConditionUl').getElementsByClassName('sku-condition-li').length; i++) {
				if (i > 1) {
					document.getElementById('skuConditionUl').getElementsByClassName('sku-condition-li')[i].setAttribute('style', 'display: none !important');
				}
			}
			this.setState({
				expand: false
			})
		} else {
			for (let i=0; i < document.getElementById('skuConditionUl').getElementsByClassName('sku-condition-li').length; i++) {
				if (i > 1) {
					document.getElementById('skuConditionUl').getElementsByClassName('sku-condition-li')[i].setAttribute('style', 'display: block !important');
				}
			}
			this.setState({
				expand: true
			})
		}

	}

	render() {
		const { opened, skuReplenishmentDetailData, isOperateFlag } = this.props;

		return (
			<Dialog dialogDidClose={()=>this.closeDialog('receiveExitOpened')} opened={ opened } options={{ bgClickClose: true }}>
					<div className='logout-dialog'>
						<Grid className='dialog-title' container spacing={0}>
							<Grid item xs={12}>
								<span>{ T('host_receive_package_condition') }</span>
							</Grid>
						</Grid>

						<Grid className='dialog-content shipping-details-dialog-content package-content-style' container spacing={0} justify={'center'}>
							<Grid item xs={12} className='simple-table-setting'>
								{ this.showConditionContent(skuReplenishmentDetailData) }
							</Grid>
						</Grid>

						<Grid container spacing={0}>
							<Grid item xs={12} align="center">
								<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.shipConfirmationHandle()}>
									<span>{ isOperateFlag === 'receive' ? T('shippment_take_goods') : T('shippment_delivery') }</span>
								</BasicButton>
								<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.closeDialog('receiveExitOpened')}>
									<span>{ T('shopping_cart_close') }</span>
								</BasicButton>
							</Grid>
						</Grid>
					</div>
			</Dialog>
		)
	}
}


export default PackageDetailsDialog;
